import { header } from 'config';
import { userStorage } from 'helpers/user-storage';

export function authHeader() {
  // Authorization header with token
  let token = userStorage.getToken();

  if (token) return { ...header, Authorization: token };
  else return {};
}
